import { render, staticRenderFns } from "./DivisionTabsDemo.vue?vue&type=template&id=59e2c1d5"
import script from "./DivisionTabsDemo.vue?vue&type=script&lang=js"
export * from "./DivisionTabsDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports